import { BaseButton, Button, Icon, ITextField, ITextFieldProps, Link, MessageBar, MessageBarType, TextField } from 'office-ui-fabric-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import Api from '../../Api';
import Auth from '../Auth';
import '../Auth.css';
import './ForgotNewPw.css';

export interface IForgotNewPwState {
  guid: string;
  password?: string;
  confPassword?: string;
  success?: boolean;
  validInput: boolean;
  validMsg?: string;
  validGuid: boolean;
  message?: string;
  messageType?: MessageBarType;
  isProcessing: boolean;
}

class ForgotNewPw extends React.PureComponent<any, IForgotNewPwState> {
  constructor(props: any) {
    super(props);

    const {
      match: { params }
    } = this.props;

    this.state = {
      guid: params.guid,
      isProcessing: false,
      validInput: false,
      validGuid: true,
      success: false
    };
    this.getForm = this.getForm.bind(this);
    this.submit = this.submit.bind(this);
    this.validateGuid = this.validateGuid.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.getErrorMessage = this.getErrorMessage.bind(this);
    this.onNotifyValidationResult = this.onNotifyValidationResult.bind(this);

    this.validatePw = this.validatePw.bind(this);
    this.validateConfPw = this.validateConfPw.bind(this);
  }

  private componentRef = React.createRef<ITextField>();

  public componentDidMount() {
    this.validateGuid();
  }

  public render(): JSX.Element {
    return (
      <Auth
        buttonShow={this.state.validGuid && !this.state.success}
        buttonText={'Submit'}
        buttonDisabled={this.state.isProcessing || !this.state.validInput}
        buttonOnClick={this.submit}
        isProcessing={this.state.isProcessing}
        messageText={this.state.message}
        messageType={this.state.messageType}
        onKeyPress={this.onKeyPress}
      >
        {this.state.validGuid ? (this.state.success ? this.getSuccessMsg() : this.getForm()) : this.getInvalidGuid()}
      </Auth>
    );
  }

  private getInvalidGuid(): JSX.Element {
    return (
      <MessageBar messageBarType={MessageBarType.blocked} isMultiline={true}>
        Password reset link is not valid! <Link href="../forgot">Try again?</Link>
      </MessageBar>
    );
  }

  private getSuccessMsg(): JSX.Element {
    return (
      <MessageBar messageBarType={MessageBarType.success} isMultiline={true}>
        Your password has been changed successfully!
      </MessageBar>
    );
  }

  private getForm(): JSX.Element {
    return (
      <>
        <div>Forgotten your password?</div>
        <div>Enter a new password for your account!</div>
        <TextField
          componentRef={this.componentRef}
          className="inputField"
          type={'password'}
          placeholder="Password"
          ariaLabel="Please enter password here"
          defaultValue={this.state.password ? this.state.password : undefined}
          disabled={this.state.isProcessing}
          deferredValidationTime={100}
          validateOnLoad={false}
          onGetErrorMessage={this.getErrorMessage}
          errorMessage={this.state.validMsg}
          onNotifyValidationResult={this.onNotifyValidationResult}
          onChange={(ev, input) => {
            this.setState({ password: input ? input : '' });
            // this.validateConfPw();
          }}
          prefix="AzureKeyVault"
          onRenderPrefix={this.onRenderPrefix}
        />
        <TextField
          className="inputField"
          type={'password'}
          placeholder="Re-enter Password"
          ariaLabel="Please confirm password"
          defaultValue={this.state.confPassword ? this.state.confPassword : undefined}
          disabled={this.state.isProcessing}
          deferredValidationTime={50}
          validateOnLoad={false}
          onGetErrorMessage={this.getErrorMessage}
          errorMessage={this.state.validMsg}
          onNotifyValidationResult={this.onNotifyValidationResult}
          onChange={(ev, input) => {
            this.setState({ confPassword: input ? input : '' });
            //  this.validatePw();
          }}
          prefix="AzureKeyVault"
          onRenderPrefix={this.onRenderPrefix}
        />
      </>
    );
  }

  private onRenderPrefix(props: ITextFieldProps | undefined): JSX.Element {
    return props ? <Icon iconName={props.prefix} /> : <></>;
  }

  private getErrorMessage(value: string): string | undefined {
    if (!value) return 'Required';
    if (this.state.password !== this.state.confPassword) {
      this.setState({ validMsg: 'Passwords must match!' });
    } else {
      this.setState({ validMsg: undefined });
    }
  }

  private onNotifyValidationResult(errorMessage: string | JSX.Element, value: string | undefined): void {
    this.setState({ validInput: !errorMessage });
  }

  private onKeyPress(ev: React.KeyboardEvent<HTMLDivElement | HTMLAnchorElement | HTMLButtonElement | BaseButton | Button>): void {
    if (ev.key === 'Enter' && this.state.validInput && !this.state.isProcessing) {
      this.submit();
    }
  }

  private validatePw(): void {
    var temp = this.state.password;
    this.setState({ password: temp + 'x' }, () => {
      this.setState({ password: temp });
    });
  }

  private validateConfPw(): void {
    var temp = this.state.confPassword;
    this.setState({ confPassword: temp + 'x' }, () => {
      this.setState({ confPassword: temp });
    });
  }

  private validateGuid(): void {
    Api.get('auth/forgot/' + this.state.guid)
      .then(response => {
        const resp: string = response.data;
        console.log('Response: ', resp);
        this.setState({ validGuid: resp ? true : false });
      })
      .catch(error => {
        console.log('error: ', error);
        console.log('error resp: ', error.response);
        const message = error.response
          ? `Request failed with status code ${error.response.status}: ${error.response.statusText}`
          : error.toJSON().message;

        this.setState({
          success: false,
          isProcessing: false,
          message: message,
          messageType: MessageBarType.error
        });
      });
  }

  private submit(): void {
    this.setState({ isProcessing: true });

    const request = {
      password: this.state.password
    };

    Api.post('auth/forgot/' + this.state.guid, request)
      .then(response => {
        const resp = response.data;
        console.log('Response: ', resp);

        this.setState({
          success: resp && resp.success,
          isProcessing: false,
          message: resp && resp.success ? '' : resp.errorMessage,
          messageType: resp && resp.success ? MessageBarType.success : MessageBarType.error
        });
      })
      .catch(error => {
        console.log('error: ', error);
        console.log('error resp: ', error.response);
        const message = error.response
          ? `Request failed with status code ${error.response.status}: ${error.response.statusText}`
          : error.toJSON().message;

        this.setState({
          success: false,
          isProcessing: false,
          message: message,
          messageType: MessageBarType.error
        });
      });
  }
}

export default withRouter(ForgotNewPw);
